export default __webpack_public_path__ + "static/media/logo-no-bg-blue.90571651.svg";